import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "ul" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.experience')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.works, (work) => {
        return (_openBlock(), _createElementBlock("article", {
          key: work.Name
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "name",
              innerHTML: work.Name
            }, null, 8, _hoisted_4),
            _createElementVNode("div", {
              class: "year",
              innerHTML: work.HowLong
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", {
            class: "position",
            innerHTML: work.Position
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(work.Tasks, (task) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: task,
                  innerHTML: task
                }, null, 8, _hoisted_8))
              }), 128))
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}